import {User} from '../../../shared/models';
import { Partenaire } from '../../../shared/models/partenaire.model';
import {ApiService} from '../../../shared/services';
import { PartenaireService } from '../../../shared/services/partenaire.service';
import {Inject} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';

export class PartenairesListResolver implements Resolve<Partenaire[]> {

  constructor( @Inject(PartenaireService) private service: PartenaireService) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Partenaire[]> {
    return this.service.list();
  }
}
